import React from 'react';

const WebSVG = ({ width, height }) => {

    return (
        <svg width={width} height={height} viewBox="0 0 23 23">
            <image xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAACoElEQVRIia2VXWiPcRTHP89/GA3Le1l5HZMLTWRS/0kuhJSXRCFz48JLaVci0aKUbBdeLseNFDGiFNJaeck0Lzdei5Vao9DGDDGd+p45PT1/Vzv1dM7vPOf3fZ7fOd/zO0nV0VYKyEhgK7AYmA7MAPqAROFtwHPgOnAtC2JQAeAaoB4YVejLQF7PduAhsBF4GwNyGZuOAGdSwB+Ae7I7gRupPQuAF8Dq/4E/BvYFQJNfQDlwXOsSYAWwLuz7DAwBmoADWeAHgUrZh4EvsjcB3cBsrYfruQxcle8WcF52HTA1gs8CDgE9+sB9YCbwBLiomA7pP8BX2ZuB3zqJ/cQx+a3I/QVtCsez/O3QejCwXzovX6IU2WmKgJ86Sb3qgU5Za1S0TS0MvHTZn28RbBfwCBgKLJKvWWkwmQJME9fv6o9NyoAKoFeMMsxq6xMzlironNKxUDl/AywJ59kFnBB4PvgnAe3Ax4D13j6aU75QI/gfIlpGGRHsCRlJHAuUyn6J2NIrxzfpPul090baFgV7WNAVsot9g78cJ51kABByj+jn0iNtNXsaYw38kxzzpN9Jz0+Bdwe7M9h+QgP/IXuOv2jRcdaos0oUMFFscZksnVPBHahMerziE8+98bwyo3gDIe05tbiDv1Lb39a6Wfe5UaxRPiv4BvlWAt/l36ZYlzpnQI10uYZEg9alStsdNZiDX5CvTYSwup0FlivGeqTRwZ+pSXICWa/CzgX2KGZMyHmx7CvSrbqs9mpdTYq7p/w200m8URpU5AdaOytqgSr5lilFaGB0pMFNVgEnZTv/TawuO2UbJS+F4eFid40NEL/jM8fcbv1JvCmtFj7CjHprU3vs1HbH2ADpl0ID+qYeY4SlyFgwOjX9X2sCnQ6N90+AvzRZkrGsT58CAAAAAElFTkSuQmCC" />
        </svg>

    )
}

export default WebSVG;


// WEBPACK FOOTER //
// ./src/components/common/svgs/WebSVG.js